export const replaceVariableInText = (
  text: string,
  searchValue: string,
  replacementValue: string,
) => {
  if (!text || !searchValue) {
    return text ?? '';
  }
  const pattern = `%${searchValue}%`;
  // Escape searchValue for regex to avoid special char issues
  const regex = new RegExp(pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');

  return text.replace(regex, replacementValue);
};
